import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import parse from 'html-react-parser'
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import Text from '../../../components/ui/text'
import Button from '../../../components/ui/button'
import SectionTitle from '../../../components/ui/section-title'
import { AboutWrapper, LeftBox, RightBox } from './about-area.style'

const AboutDesc = ({ sectionTitleStyle, headingStyle, textStyle, subTextStyle, descStyle, btnStyle }) => {
    const AboutDescData = useStaticQuery(graphql`
        query AboutPageDescQuery {
            aboutUsJson(jsonId: {eq: "about-page-intro"}) {
                section_title {
                    title
                    subtitle
                }
                heading
                text
                subText
                desc
                path
            }
        } 
    `);
    const aboutUsJson = AboutDescData.aboutUsJson;
    if (!aboutUsJson) {
        console.warn("AboutDesc: aboutUsJson is null");
        return null;
    }
    const { section_title: { title, subtitle }, heading, text, subText, desc, path } = aboutUsJson;
    return (
        <AboutWrapper>
            <Container>
                <Row>
                    <Col lg={7} md={9} ml="auto" mr="auto">
                        <SectionTitle
                            {...sectionTitleStyle}
                            title={title}
                            subtitle={subtitle}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 4, offset: 1 }} xs={{ alignSelf: 'center' }}>
                        <LeftBox>
                            {heading && <Heading {...headingStyle}>{parse(heading)}</Heading>}
                            {text && <Heading {...textStyle}>{parse(text)}</Heading>}
                            {subText && <Heading {...subTextStyle}>{parse(subText)}</Heading>}
                        </LeftBox>
                    </Col>
                    <Col lg={{ span: 5, offset: 1 }}>
                        <RightBox>
                            {desc && <Text {...descStyle}>{parse(desc)}</Text>}
                            {path && <Button {...btnStyle} to={`/${path}`}>Discover More</Button>}
                        </RightBox>
                    </Col>
                </Row>
            </Container>
        </AboutWrapper>
    )
}

AboutDesc.propTypes = {
    sectionStyle: PropTypes.object,
    sectionTitleStyle: PropTypes.object,
    headingStyle: PropTypes.object,
    textStyle: PropTypes.object,
    subTextStyle: PropTypes.object,
    descStyle: PropTypes.object,
}

AboutDesc.defaultProps = {
    sectionTitleStyle: {
        mb: '70px',
        responsive: {
            small: {
                mb: '30px'
            }
        }
    },
    headingStyle: {
        as: "h3",
        layout: "highlight",
        maxwidth: "330px",
        mb: "24px",
        responsive: {
            medium: {
                maxwidth: "100%"
            }
        }
    },
    textStyle: {
        as: "h4",
        fontSize: "20px"
    },
    subTextStyle: {
        as: "h3",
        mt: "24px",
        maxwidth: "200px",
        color: "#4b1e79",
        responsive: {
            medium: {
                maxwidth: "100%"
            }
        }
    },
    descStyle: {
        fontSize: "18px",
        lineHeight: 1.67,
        mb: "23px"
    },
    btnStyle: {
        varient: "texted",
        iconname: "far fa-long-arrow-right",
        hover: "false"
    }
}

export default AboutDesc;